import React from "react";
import { TATVA_PHOTO_WYNN_B64 } from "../lib/tatvaPhotoWynn";

/** Wynn — Head of Automation · Entertainment (cover letter). */

const CREAM = "#f4ede0";
const INK = "#1a1a1a";
const INK_SOFT = "#3a342b";
const BRONZE = "#8a6f47";
const RULE_SOFT = "rgba(26,26,26,0.10)";
const SERIF = '"Playfair Display", Georgia, "Times New Roman", serif';
const SANS = "Inter, -apple-system, BlinkMacSystemFont, sans-serif";

const Eyebrow = ({ children }) => (
    <p style={{ fontFamily: SANS, color: BRONZE, fontSize: 9, letterSpacing: "0.36em", textTransform: "uppercase", fontWeight: 600, margin: 0 }}>
        {children}
    </p>
);

export const WynnAutomationCoverSheet = () => (
    <article className="cover-page" data-testid="cover-letter-sheet"
        style={{ width: 794, height: 1120, maxWidth: "100%", margin: "0 auto", backgroundColor: CREAM, color: INK, boxShadow: "0 24px 60px rgba(0,0,0,0.18), 0 0 0 1px rgba(26,26,26,0.06)", padding: "56px 80px 44px", boxSizing: "border-box", position: "relative", fontFamily: SANS, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 22, paddingBottom: 18, borderBottom: `1px solid ${RULE_SOFT}`, marginBottom: 26 }}>
            <div style={{ flex: 1 }}>
                <h1 style={{ fontFamily: SERIF, fontSize: 32, fontWeight: 500, color: INK, margin: 0, letterSpacing: "-0.02em", lineHeight: 1 }}>Aditya Anand</h1>
                <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 12, color: BRONZE, margin: "4px 0 0" }}>
                    Known professionally as Tatva K
                </p>
                <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 12, color: INK_SOFT, margin: "6px 0 0" }}>
                    Live AV Production &middot; Sound Engineer &middot; Broadcast Producer
                </p>
                <p style={{ fontFamily: SANS, fontSize: 9.5, color: INK_SOFT, margin: "10px 0 0", letterSpacing: "0.04em", lineHeight: 1.55 }}>
                    Al Hamra Village, Ras Al Khaimah, UAE
                    <br />
                    tatvak@theresetsanctuary.org &middot; +971 50 676 9007
                </p>
            </div>
            <img src={TATVA_PHOTO_WYNN_B64} alt="Tatva K" style={{ width: 92, height: 110, objectFit: "cover", border: `1px solid rgba(26,26,26,0.18)`, flexShrink: 0 }} />
        </header>

        <div style={{ fontFamily: SANS, fontSize: 9.5, color: BRONZE, letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 600, margin: "0 0 22px" }}>
            Re: Head of Automation &mdash; Entertainment
        </div>

        <section style={{ fontFamily: SERIF, fontSize: 12, lineHeight: 1.6, color: INK_SOFT, fontWeight: 400 }}>
            <p style={{ margin: "0 0 11px" }}>Dear hiring team,</p>

            <p style={{ margin: "0 0 11px" }}>
                I am writing to apply for the <strong style={{ color: INK }}>Head of Automation &mdash; Entertainment</strong>{" "}
                position at Wynn Al Marjan Island. I am a UAE resident based in Al Hamra Village, Ras Al Khaimah,
                available on-site immediately and prepared to commit fully to the pre-opening team.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                My profile sits at an unusual intersection: twenty years of live AV production combined with current,
                hands-on systems engineering. On the AV side, I performed on the{" "}
                <strong style={{ color: INK }}>Sunburn Festival mainstage from 2006 through 2009</strong>, executive-produced
                a flagship national radio show on <strong style={{ color: INK }}>Zabardast Hit 95&nbsp;FM for thirteen years</strong>,
                and have engineered commercial releases totalling over 200 million streams. On the systems side, I
                currently architect and operate a production-grade backend (FastAPI, Meta Conversions API, server-side
                Stripe webhooks, dedup&rsquo;d event pipelines) for The Reset Sanctuary &mdash; the same uptime-first,
                fail-safe thinking show automation requires.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                I am <strong style={{ color: INK }}>Berklee-trained</strong>, an Ableton Live user since 2004, and
                work daily across modern AI tooling &mdash; Claude and Emergent APIs for prompt logic and pipeline design,
                ElevenLabs for voice synthesis, Kaiber AI for generative video. The next decade of resort entertainment
                will be increasingly automated and AI-augmented; my background gives me the rare ability to bridge
                traditional AV signal flow with modern automation and show-control workflows.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                As Founder of Chill Om Records &amp; Studios and Founder of The Reset Sanctuary, I have led teams,
                managed equipment lifecycles, owned vendor relationships and operated daily quality control. I treat
                automation systems the way the role requires &mdash; as mission-critical utilities with measurable
                uptime targets, not as one-off installations.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                I would welcome the opportunity to discuss how my combined live AV and systems background can serve the
                Entertainment Technical Services team at Wynn Al Marjan Island. I am happy to meet on-site at your
                convenience.
            </p>

            <p style={{ margin: 0 }}>Thank you for your time and consideration.</p>
        </section>

        <div style={{ marginTop: "auto", paddingTop: 22, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div>
                <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 22, color: INK, margin: 0, letterSpacing: "-0.01em", lineHeight: 1 }}>Warm regards,</p>
                <p style={{ fontFamily: SERIF, fontSize: 20, color: BRONZE, margin: "8px 0 0", fontWeight: 500, letterSpacing: "-0.01em" }}>Aditya Anand</p>
            </div>
            <div style={{ textAlign: "right" }}>
                <Eyebrow>Entertainment &middot; Head of Automation</Eyebrow>
                <p style={{ fontFamily: SANS, fontSize: 9.5, color: INK_SOFT, margin: "8px 0 0", letterSpacing: "0.04em", lineHeight: 1.6 }}>
                    UAE Resident &middot; On-site Ready
                </p>
            </div>
        </div>
    </article>
);
